import React, { useState } from 'react';

const CATEGORIES = [
  { key: 'alcool', label: 'Alcools' },
  { key: 'biere', label: 'Bières' },
  { key: 'eau', label: 'Eaux' },
  { key: 'soda', label: 'Sodas' },
  { key: 'jus', label: 'Jus' },
  { key: 'soft', label: 'Divers' },
];

export default function BoissonFormModal({ boisson, onSave, onCancel }) {
  const [nom, setNom] = useState(boisson?.nom || '');
  const [quantite, setQuantite] = useState(boisson?.quantite_souhaitee || 1);
  const [emoji, setEmoji] = useState(boisson?.emoji || '🥤');
  const [categorie, setCategorie] = useState(boisson?.categorie || 'alcool');
  const [error, setError] = useState('');
  const [saving, setSaving] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!nom.trim() || !emoji.trim() || Number(quantite) < 1) {
      setError('Merci de remplir tous les champs.');
      return;
    }
    setSaving(true);
    setError('');
    try {
      await onSave({ nom: nom.trim(), quantite_souhaitee: Number(quantite), emoji: emoji.trim(), categorie });
    } catch (err) {
      setError(err.message || 'Erreur, réessaie.');
      setSaving(false);
    }
  };

  return (
    <div
      onClick={onCancel}
      style={{
        position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.45)', zIndex: 1000,
        display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '1.5rem'
      }}
    >
      <div
        onClick={e => e.stopPropagation()}
        className="party-card p-4"
        style={{ maxWidth: 380, width: '100%' }}
      >
        <h3 style={{ fontWeight: 800, color: '#1a2e35', fontSize: '1.15rem', marginBottom: '1rem' }}>
          {boisson ? 'Modifier la boisson' : 'Ajouter une boisson'}
        </h3>
        <form onSubmit={submit}>
          <div className="mb-2">
            <label style={{ fontSize: '0.8rem', fontWeight: 700, color: '#607d8b' }}>Nom</label>
            <input
              type="text"
              className="name-input"
              style={{ fontSize: '0.95rem', padding: '0.6rem 1rem' }}
              value={nom}
              onChange={e => setNom(e.target.value)}
              autoFocus
            />
          </div>
          <div className="d-flex gap-2 mb-2">
            <div style={{ flex: 1 }}>
              <label style={{ fontSize: '0.8rem', fontWeight: 700, color: '#607d8b' }}>Emoji</label>
              <input
                type="text"
                className="name-input"
                style={{ fontSize: '0.95rem', padding: '0.6rem 1rem' }}
                value={emoji}
                onChange={e => setEmoji(e.target.value)}
              />
            </div>
            <div style={{ flex: 1 }}>
              <label style={{ fontSize: '0.8rem', fontWeight: 700, color: '#607d8b' }}>Quantité souhaitée</label>
              <input
                type="number"
                min="1"
                className="name-input"
                style={{ fontSize: '0.95rem', padding: '0.6rem 1rem' }}
                value={quantite}
                onChange={e => setQuantite(e.target.value)}
              />
            </div>
          </div>
          <div className="mb-3">
            <label style={{ fontSize: '0.8rem', fontWeight: 700, color: '#607d8b' }}>Catégorie</label>
            <select
              className="name-input"
              style={{ fontSize: '0.95rem', padding: '0.6rem 1rem' }}
              value={categorie}
              onChange={e => setCategorie(e.target.value)}
            >
              {CATEGORIES.map(c => <option key={c.key} value={c.key}>{c.label}</option>)}
            </select>
          </div>
          {error && <div className="alert alert-danger py-2 px-3 rounded-pill text-center mb-3" style={{ fontSize: '0.85rem' }}>{error}</div>}
          <div style={{ display: 'flex', gap: '0.6rem' }}>
            <button
              type="button"
              onClick={onCancel}
              className="btn"
              style={{ flex: 1, borderRadius: '50px', fontWeight: 700, background: '#eceff1', color: '#455a64', border: 'none', padding: '0.7rem' }}
            >
              Annuler
            </button>
            <button
              type="submit"
              disabled={saving}
              className="btn btn-party"
              style={{ flex: 1, padding: '0.7rem' }}
            >
              {saving ? <span className="spinner-border spinner-border-sm" /> : 'Enregistrer'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
